import { useLanguage } from '../contexts/LanguageContext';
import { en, ar } from './translations';

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const translations = language === 'ar' ? ar : en;
  
  const t = (key) => {
    const keys = key.split('.');
    let value = translations;
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation key "${key}" not found`);
        return key;
      }
    }
    
    return value || key;
  };
  
  return { t, language };
};
